import type { OnboardingLogo } from "./mergePrefillIntoFormValues.js";

export const LOGO_MAX_BYTES = 5 * 1024 * 1024;

export const LOGO_ACCEPTED_MIME_TYPES = [
  "image/png",
  "image/svg+xml",
  "image/jpeg",
];

export type LogoFileProblem = "type" | "size";

/** Why a dropped file cannot be the company logo, or `null` when it can. */
export function getLogoFileProblem(file: {
  type: string;
  size: number;
}): LogoFileProblem | null {
  if (!LOGO_ACCEPTED_MIME_TYPES.includes(file.type)) {
    return "type";
  }
  return file.size > LOGO_MAX_BYTES ? "size" : null;
}

/** The logo as `updateOrganisation.logo` takes it: no ids, no group. */
export function toLogoInput(logo: OnboardingLogo): {
  url: string;
  title: string | null;
  mimeType: string | null;
} {
  return {
    url: logo.url,
    title: logo.title ?? null,
    mimeType: logo.mimeType ?? null,
  };
}
